import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';
import LocalStorageChecker from '../Miscelania/LocalStorageChecker';

class LocalStorageIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    // Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.clearLocalStorage = this.clearLocalStorage.bind(this);
    this.removeOldReportsFromLocalStorage = this.removeOldReportsFromLocalStorage.bind(this);
  }
  // Handlers
  handleAlert(message, type, status, mode) {
    if (mode === 'reset') {
      this.setState({ overlay: { message: '', type: '', status: 'closed' } });
    } else {
      this.setState({ overlay: { message: message, type: type, status: status } });
    }
  }

  handleLoaded(state) {
    if (this.state.loaded !== 2) {
      this.setState({ loaded: state });
    }
  }

  handleChangeDatePicker(state, date) {
    var change = {};
    change[state] = date.format("DD/MM/YYYY");
    this.setState(change);
  }

  handleMessage() {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      localStorage.data = JSON.stringify(this.state.data);
    }
  }

  clearLocalStorage() {
    this.localStorageCheckerRef.clearLocalStorage(true);
    alert('Cache zerado com sucesso!');
  }

  removeOldReportsFromLocalStorage() {
    this.localStorageCheckerRef.removeOldReportsFromLocalStorage(true);
    alert('Relatórios com mais de 02 dias removidos do cache com sucesso!');
  }

  render() {
    return (
      <div>
        <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <LocalStorageChecker ref={(ref) => { this.localStorageCheckerRef = ref; }} />
        <div className="container-liquid">
          <div className="conteudo">
            <h3 className="page-title pull-left">Dados em cache</h3>
            <div className="clearfix"></div>
            <hr />
            <div className="form-group">
              <div className="row">
                <div className="col-md-12">
                  <button className="btn btn-danger btn-group btn-block" onClick={this.clearLocalStorage}>Limpar todo cache</button>
                </div>
              </div>
              <br/>
              <div className="row">
                <div className="col-md-12">
                  <button className="btn btn-warning btn-group btn-block" onClick={this.removeOldReportsFromLocalStorage}>Remover cache de relatórios de mais de 02 dias atrás</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LocalStorageIndex;


// WEBPACK FOOTER //
// ./src/Components/Users/LocalStorageIndex.js